import e from "@dialpad/dialtone-tokens/layered/themes/tokens-128-colors.css?inline";
//#region themes/128.js
var t = { brand: {
	css: e,
	name: "128"
} };
//#endregion
export { t as default };
